import { useQuery } from "@tanstack/react-query";
import { useEffect, useState } from "react";
import { Badge, Col, Row } from "react-bootstrap";
import { TailSpin } from "react-loader-spinner";
import { useSessionStorage } from "usehooks-ts";

function ProfileContent(props) {
  const api = process.env.REACT_APP_DATABASE_URI;
  const [authcode, ,] = useSessionStorage("authToken", "");
  const [desc, setDesc] = useState();
  const [nationality, setNationality] = useState();
  const [languages, setLanguages] = useState([]);
  const {
    isPending,
    isError,
    data: myApplications,
    error,
  } = useQuery({
    queryKey: ["my-applications"],
    retry: false,
    queryFn: () =>
      fetch(`${api}/applications/my`, {
        mode: "cors",
        headers: {
          accept: "application/json",
          Authorization: `Bearer ${authcode}`,
        },
      }).then((res) => {
        if (!res.ok) {
          throw new Error("Network response was not ok ", error);
        }
        return res.json();
      }),
  });

  useEffect(() => {
    setDesc(
      props.profileData?.summary ?? "This user has not set his expa description"
    );
    setNationality(
      props.profileData?.home_mc_full_name?.split(" ").slice(2).join(" ") ?? ""
    );
    setLanguages(props.profileData?.languages ?? []);
  }, [props.profileData]);
  return (
    <div className="profileDesc">
      <div className="profileParagraph">
        <p className="title">Description</p>
        <p>{desc}</p>
      </div>
      <div className="dataBadges profileParagraph">
        <Row>
          <Col className="infoData">
            <p className="title">
              Nationality <Badge>{nationality}</Badge>
            </p>
          </Col>
          <Col className="infoData">
            <p className="title">Skills {/* <Badge>Tunisia</Badge> */}</p>
          </Col>
          <Col className="infoData">
            <p className="title">
              Languages{" "}
              {languages.map((ele) => {
                return <Badge key={ele}>{ele}</Badge>;
              })}
            </p>
          </Col>
        </Row>
      </div>
      <div className="profileParagraph">
        <p className="title">Applications</p>
        <ul>
          {isPending && (
            <TailSpin
              visible={true}
              height="150"
              width="150"
              color="#037EF2"
              ariaLabel="tail-spin-loading"
              radius="1"
              wrapperClass="spinner"
            />
          )}
          {isError && <p>{error.message}</p>}
          {myApplications?.map((application) => {
            return (
              <li key={application.id}>
                {application.title} - CONFERENCE NAME
              </li>
            );
          })}
        </ul>
      </div>
      <div className="profileParagraph">
        <p className="title">Past Experiences</p>
        <ul>
          <li>Borem ipsum dolor sit amet, consectetur adipiscing elit. </li>
          <li>Borem ipsum dolor sit amet, consectetur adipiscing elit. </li>
          <li>Borem ipsum dolor sit amet, consectetur adipiscing elit. </li>
        </ul>
      </div>
    </div>
  );
}
export default ProfileContent;
